import { FormSectionHandler } from '../entity.handler';
import { SmsGatewayProviderResponse, SmsGatewayProviderUpdateRequest, IdName } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField, IdNameComboValueHandlers } from 'app/shared/components/form-builder';
import { TextField, EntityUtils, ComboField } from '../utils';
import { ICONS } from '../icons';

interface EditorValues {
    name?: string;
    type?: IdName;
}

export class SmsGatewayDetailsSectionHandler implements FormSectionHandler<SmsGatewayProviderResponse, EditorValues> {

    type = 'form';
    icon = ICONS.smsgateway;
    bulk = false;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string,
        public creating: boolean
    ) {
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.SMSGATEWAYPROVIDER.DETAILS.${key}`, values);
    }

    applyUpdate(entity: SmsGatewayProviderResponse, payload: SmsGatewayProviderUpdateRequest): Promise<SmsGatewayProviderResponse> {
        return this.admin.applyUpdate(api => api.entities.updateSmsGatewayProvider(entity.id, payload));
    }

    mapEntityToEditor(entity: SmsGatewayProviderResponse): Promise<EditorValues> {
        const result = {
            name: entity.name,
            type: entity.type,
        };
        Object.keys(result).forEach(key => result[key] === undefined && delete result[key]); // strip undefined properties from the object
        return Promise.resolve(result);
    }

    mapEditorToEntity(entity: SmsGatewayProviderUpdateRequest, values: EditorValues): Promise<SmsGatewayProviderUpdateRequest> {

        const patch: SmsGatewayProviderUpdateRequest = {
            name: values.name,
            type: values.type,
        };
        Object.keys(patch).forEach(key => patch[key] === undefined && delete patch[key]); // strip undefined properties from the object

        return Promise.resolve(EntityUtils.mergeFields(['name', 'type'], patch, entity));

    }

    async getFields(entity: SmsGatewayProviderResponse): Promise<FormBuilderField[]> {
        const types = await this.admin.getCached(`listSmsGatewayProviderTypes/${this.ownerId}/0/100/name/null`, api => api.entities.listSmsGatewayProviderTypes(this.ownerId, 0, 100, 'name', null));
        const fields: FormBuilderField[] = [
            { ...ComboField('type', this.translate('FIELDS.TYPE'), true, EntityUtils.idNameToComboValues(types.items), IdNameComboValueHandlers), readonly: !this.creating },
            TextField('name', this.translate('FIELDS.NAME'), true, 1, 255),
        ];
        return EntityUtils.prepareBulk(!entity, [], fields);

    }

}
